import { combineReducers } from 'redux';
import messageReducer from '../../components/modal/modal-reducer';
import errorsReducer from './errors/errors-reducer';
import busyIndicatorReducer from '../../components/busy-indicator/busy-indicator-reducer';
import classDetailsReducer from '../class-details/class-details-reducer';
import academicYearReducer from '../overview/academic-year-reducer';
import selectedDateReducer from '../../components/date-picker/date-picker-reducer';
import overviewReducer from '../overview/overview-reducer';
import selectedClassReducer from '../overview/selected-class-reducer';
import productIdReducer from '../app/product-id/product-id-reducer';
import schoolIdReducer from '../overview/school-id-reducer';
import participationReportReducer from '../participation-report/participation-report-reducer';
import selectedStudentReducer from '../class-details/selected-student-reducer';
import studentCertificatesReducer from '../certificates/student-certificates-reducer';
import studentCertificatesGemCountReducer from '../certificates/student-certificates-gem-count-reducer';
import localeReducer from '../../locale/locale-reducer';
import toastReducer from '../../components/toast/toast-reducer';
import downloadCertificatesReducer from '../certificates/download-certificates-reducer';

const CombinedReducers = combineReducers({
    modalMessages: messageReducer,
    errors: errorsReducer,
    busyIndicatorCount: busyIndicatorReducer,
    classDetailsData: classDetailsReducer,
    academicYear: academicYearReducer,
    selectedDateRange: selectedDateReducer,
    classOverviewData: overviewReducer,
    selectedClass: selectedClassReducer,
    productId: productIdReducer,
    schoolId: schoolIdReducer,
    participationReport: participationReportReducer,
    selectedStudent: selectedStudentReducer,
    studentCertificates: studentCertificatesReducer,
    studentCertificatesGemCount: studentCertificatesGemCountReducer,
    localeData: localeReducer,
    toastData: toastReducer,
    downloadCertificatesState: downloadCertificatesReducer
});

export default CombinedReducers;



// WEBPACK FOOTER //
// ./containers/app/combined-reducers.js